function BeritaAcaraIcon(props) {
  const { isActive } = props
  return (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.1333 7.60001L9.33333 11.4H7.8V9.86668L11.6 6.06668L13.1333 7.60001ZM15.4 7.06668C15.4 7.26668 15.2 7.46668 15 7.66668L13.3333 9.33334L12.7333 8.73334L14.4667 7.00001L14.0667 6.60001L13.6 7.06668L12.0667 5.53334L13.5333 4.13334C13.6667 4.00001 13.9333 4.00001 14.1333 4.13334L15.0667 5.06668C15.2 5.20001 15.2 5.46668 15.0667 5.66668C14.9333 5.80001 14.8 5.93334 14.8 6.06668C14.8 6.20001 14.9333 6.33334 15.0667 6.46668C15.2667 6.66668 15.4667 6.86668 15.4 7.06668ZM2 12.3333V1.66668H6.66667V5.00001H10V6.00001L11.3333 4.66668V4.33334L7.33333 0.333344H2C1.26667 0.333344 0.666666 0.933344 0.666666 1.66668V12.3333C0.666666 13.0667 1.26667 13.6667 2 13.6667H10C10.7333 13.6667 11.3333 13.0667 11.3333 12.3333H2ZM7.33333 10.4C7.2 10.4 7.06667 10.4667 7 10.4667L6.66667 9.00001H5.66667L4.26667 10.1333L4.66667 8.33334H3.66667L3 11.6667H4L5.93333 9.93334L6.33333 11.4667H7L7.33333 11.4V10.4Z"
        fill={!isActive ? '#828282' : '#FFFFFF'}
      />
    </svg>
  )
}

export default BeritaAcaraIcon
